import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./NotificationModal.css";

export default function NotificationModal({ notification, onClose }) {

  useEffect(() => {

    const esc = (e) => {
      if (e.key === "Escape") onClose();
    };

    // page scroll lock
    document.body.style.overflow = "hidden";

    window.addEventListener("keydown", esc);

    return () => {
      window.removeEventListener("keydown", esc);
      document.body.style.overflow = "auto";
    };

  }, [onClose]);

  if (!notification) return null;

  const value = notification.value || 1;

  const valueColor = {
    1: "#3b82f6", // info
    2: "#22c55e", // success
    3: "#ef4444"  // critical
  }[value];

  return createPortal(

    <div className="notif-modal-root">

      <div
        className="notif-modal-backdrop"
        onClick={onClose}
      />

      <div className="notif-modal">

        {/* HEADER */}

        <div
          className="notif-modal-header"
          style={{ borderColor: valueColor }}
        >

          <h3>{notification.title}</h3>

          <button
            className="notif-modal-close"
            onClick={onClose}
          >
            ✕
          </button>

        </div>

        {/* BODY */}

        <div className="notif-modal-body">

          <div
            className="notif-html"
            dangerouslySetInnerHTML={{
              __html: notification.bodyHtml || notification.notifyBody
            }}
          />

        </div>

        {/* ACTION */}

        {notification.action?.route && (

          <div className="notif-modal-footer">

            <button
              className="notif-action-btn"
              onClick={() => {
                window.location.assign(notification.action.route);
              }}
            >
              {notification.action.label}
            </button>

          </div>

        )}

      </div>

    </div>,

    document.body
  );
}